import { theme } from '@beamery/lib-ds-theme';
import React from 'react';
import { omit } from '../../utils/index.js';
import { LabelElement } from './label.styles.js';
export const Label = React.forwardRef(({ elementType = 'label', ...props }, ref) => (React.createElement(LabelElement, { ref: ref, elementType: elementType, ...(props.variant === 'paragraph'
        ? theme.styles.paragraphs.default
        : theme.styles.uiText.label), ...omit(props, 'variant') })));
//# sourceMappingURL=label.component.js.map